import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import React, { createContext } from 'react';
export var LayoutContext = createContext();
export function LayoutProvider(_ref) {
  var layout = _ref.layout,
      props = _objectWithoutProperties(_ref, ["layout"]);

  return React.createElement(LayoutContext.Provider, _extends({}, props, {
    value: layout
  }));
}
export var withLayout = function withLayout(WrappedComponent) {
  function WithLayout(props) {
    return React.createElement(LayoutContext.Consumer, null, function (layout) {
      return React.createElement(WrappedComponent, _extends({
        layout: layout
      }, props));
    });
  }

  return WithLayout;
};